import type { PlanId, RestaurantId } from '~/lib/graphql/scalars'

export const GRAPHQL_API_ROUTES_PATH = `/api/v2/graphql`

export function planDetailPagePath(restaurantId: RestaurantId, planId: PlanId) {
  return `/${restaurantId}/plan${planId}`
}

// ガイド下部レコメンドカードのリンク先のパスを作る。search内のパラメータのうち来店条件だけリンク先に引き継ぎ、
// それ以外の条件はリンク先に在庫がないように見えるのを防ぐために除外する。
export function recommendCardLinkPath(restaurantId: RestaurantId, search: string) {
  const visitingCriteria = ['visitorsCount', 'visitDate', 'visitTime']
  const filteredParams = Array.from(new URLSearchParams(search)).filter(([key]) =>
    visitingCriteria.includes(key)
  )

  if (filteredParams.length === 0) {
    return `/${restaurantId}`
  }

  const forwardedParams = new URLSearchParams(filteredParams)
  return `/${restaurantId}?${forwardedParams}`
}

if (import.meta.vitest) {
  const { expect, test } = import.meta.vitest

  test('recommendCardLinkPath', () => {
    expect(recommendCardLinkPath('100000' as RestaurantId, '')).toBe('/100000')
    expect(recommendCardLinkPath('100000' as RestaurantId, '?visitorsCount=2')).toBe(
      '/100000?visitorsCount=2'
    )

    expect(
      recommendCardLinkPath(
        '100000' as RestaurantId,
        '?visitorsCount=2&visitDate=2025-01-01&visitTime=19%3A00'
      )
    ).toBe('/100000?visitorsCount=2&visitDate=2025-01-01&visitTime=19%3A00')

    expect(
      recommendCardLinkPath(
        '100000' as RestaurantId,
        '?max_price=20000&seatTypes=PRIVATE_ROOM&visitorsCount=2&visitDate=2025-01-01&visitTime=19%3A00'
      )
    ).toBe('/100000?visitorsCount=2&visitDate=2025-01-01&visitTime=19%3A00')
  })
}
